(function () {
  'use strict';

  /* @ngdoc object
   * @name navigation
   * @description
   *
   */
  angular
    .module('navigation', [
      'ui.router'
    ]);
}());
